import valuesIn from 'lodash/valuesIn'
import some from 'lodash/some'

export const getIsModal = ({ modal }) => some(valuesIn(modal), Boolean)
